import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import IncidentDetails from './IncidentDetails';
import IncidentList from './IncidentList';

import './Incidents.css';

const IncidentsPage = props => {
  return (
    <Fragment>
      <Route exact path="/" component={IncidentList} />
      <Route exact path="/incidents" component={IncidentList} />
      <Route path="/incidents/:id" component={IncidentDetails} />
    </Fragment>
  );
};

export default IncidentsPage;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentsPage.js